import dayjs from 'dayjs'
import { find, omit } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import Actions from '../../../../actions'
import ResidentEditForm from '../../../../components/forms/screens/ResidentEditForm'
import { withRouter } from '../../../../withRouter'

export class ResidentEditScreen extends React.Component {
  componentDidMount() {
    this.populateForm(this.props.residents)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.residents && nextProps.residents) {
      this.populateForm(nextProps.residents)
    }
  }

  formatDate = (date) => dayjs(date).format('DD-MM-YYYY')

  populateForm = (residentsList) => {
    const { addForm, router } = this.props
    const profile = find(residentsList, { id: router.params.id })

    const admissionDate = profile?.admissionDate
      ? this.formatDate(profile.admissionDate)
      : undefined

    const dolsReviewDate = profile?.dolsReviewDate
      ? this.formatDate(profile.dolsReviewDate)
      : undefined

    const dolsApplicationDate = profile?.dolsApplicationDate
      ? this.formatDate(profile.dolsApplicationDate)
      : undefined

    const dolsStartDate = profile?.dolsStartDate
      ? this.formatDate(profile.dolsStartDate)
      : undefined

    const dolsEndDate = profile?.dolsEndDate
      ? this.formatDate(profile.dolsEndDate)
      : undefined

    if (!profile) return null
    const location = profile.location
      ? {
          'location.building': profile.location.building,
          'location.floor': profile.location.floor,
          'location.room': profile.location?.room,
          'location.bed': profile.location.bed
        }
      : {}

    let dolsObject = {
      dolsApplicationDate: dolsApplicationDate || null,
      dolsReviewDate: dolsReviewDate || null,
      dolsStartDate: dolsStartDate || null,
      dolsEndDate: dolsEndDate || null
    }
    if (!profile.dols) {
      dolsObject = {
        dolsApplicationDate: null,
        dolsReviewDate: null,
        dolsStartDate: null,
        dolsEndDate: null
      }
    }

    addForm({
      ...omit(profile, 'location'),
      ...location,
      dateOfBirth: dayjs(profile.dateOfBirth).format('DD-MM-YYYY'),
      admissionDate,
      ...dolsObject
    })
  }

  render() {
    const { residents, router } = this.props
    const profile = find(residents, { id: router.params.id })
    if (!router.params || !residents) return null
    return (
      <div data-testid="resident-edit-screen">
        <ResidentEditForm profile={profile} testId="resident-edit" />
      </div>
    )
  }
}

ResidentEditScreen.propTypes = {
  addForm: PropTypes.func.isRequired,
  residents: PropTypes.array
}

const mapStateToProps = (state) => ({
  residents: state.data.residents
})

const mapDispatchToProps = (dispatch) => ({
  addForm: (profile) =>
    dispatch(
      Actions.addForm({
        formId: 'editResident',
        initial: profile
      })
    )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ResidentEditScreen))
